/**
 * Hover "quick download" buttons (View Options / Download Now) for product
 * tiles rendered by Klevu on collection/search/filter pages.
 *

 */
(function () {
  "use strict";

  var processedTiles = new WeakSet();
  var dataCache = new Map();
  var activePopover = null;

  function getProductHandle(href) {
    try {
      var url = new URL(href, window.location.origin);
      var parts = url.pathname.split("/").filter(Boolean);
      var idx = parts.indexOf("products");
      return idx !== -1 && parts[idx + 1] ? parts[idx + 1] : null;
    } catch (e) {
      return null;
    }
  }

  function isPlanAllowed() {
    var classes = document.body.classList;
    if (classes.contains("plan-status-canceled")) return false;
    return (
      classes.contains("plan-Pro") ||
      classes.contains("plan-Media") ||
      classes.contains("plan-Trial")
    );
  }

  function fetchQuickDownloadData(handle) {
    if (dataCache.has(handle)) return dataCache.get(handle);
    var url = "/products/" + handle + "?view=quick-download";
    var promise = fetch(url)
      .then(function (res) {
        if (!res.ok) {
          console.warn("[quick-download-grid] bad response", res.status, url);
          return null;
        }
        return res.json();
      })
      .catch(function (err) {
        console.warn("[quick-download-grid] fetch failed", url, err);
        return null;
      });
    dataCache.set(handle, promise);
    return promise;
  }

  function getCurrentDownloadCount() {
    var match = Array.prototype.find.call(
      document.body.classList,
      function (cls) {
        return cls.indexOf("downloads-") === 0;
      }
    );
    return match ? parseInt(match.split("-")[1], 10) || 0 : 0;
  }

  function recordDownload(data, format, resolution) {
    if (window.qdlCustomerId && typeof updateMetfafields === "function") {
      updateMetfafields(
        { number_of_downloads: getCurrentDownloadCount() + 1 },
        window.qdlCustomerId
      );
    }
    if (typeof saveDownload === "function") {
      saveDownload({
        customer_id: window.qdlCustomerId,
        product_name: data.title,
        product_url: data.thumbnail,
        product_producer: data.producer,
        product_format: (format || "").toLowerCase(),
        product_resolution: (resolution || "").toLowerCase(),
        subscription_type: window.qdlCustomerPlan,
        old_customer_id: "",
        product_type: data.productType,
        shopify_product_url: "products/" + data.handle,
      }).catch(function () {});
    }
  }

  function triggerDownload(url, title, format, resolution) {
    var link = document.createElement("a");
    link.href = url;
    link.download =
      (title || "download").toLowerCase().replace(/\s+/g, "-") +
      "-" +
      (resolution || "") +
      "." +
      (format || "");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function extractLinkInfo(link) {
    var parts = (link.variant || "").split("_");
    return {
      format: (parts[0] || "unknown").toLowerCase(),
      resolution: (parts[1] || "unknown").toLowerCase(),
    };
  }

  function getPreferences(type) {
    var lower = (type || "").toLowerCase();
    if (lower === "motions") {
      return {
        format: (window.qdlMotionFormat || "").toLowerCase(),
        resolution: (window.qdlMotionResolution || "").toLowerCase(),
        width: (window.qdlMotionSize || "").toLowerCase(),
      };
    }
    if (lower === "stills") {
      return {
        resolution: (window.qdlStillResolution || "").toLowerCase(),
        width: (window.qdlStillSize || "").toLowerCase(),
      };
    }
    return {};
  }

  function selectLinkByPreference(links, type, prefs) {
    var lower = (type || "").toLowerCase();
    var isMotion = lower === "motions";
    var isStill = lower === "stills";
    if (!isMotion && !isStill) return links[0];

    var hasPreference = isMotion
      ? !!(prefs.format || prefs.resolution || prefs.width)
      : !!(prefs.resolution || prefs.width);
    if (!hasPreference) return links[0];

    var matches = links.filter(function (link) {
      var parts = (link.variant || "").toLowerCase().split("_");
      var format = parts[0] || "";
      var resolution = parts[1] || "";
      var width = parts[2] || "sw";
      if (isMotion && prefs.format && format !== prefs.format) return false;
      if (prefs.resolution && resolution !== prefs.resolution) return false;
      if (prefs.width && width !== prefs.width) return false;
      return true;
    });
    return matches[0] || null;
  }

  var GEAR_BUTTON_TYPES = ["motions", "stills", "mini movies", "countdowns"];

  function shouldShowGearButton(data) {
    var typeNeedsModal =
      GEAR_BUTTON_TYPES.indexOf((data.productType || "").toLowerCase()) !== -1;
    return typeNeedsModal && parseDownloadLinks(data).length > 1;
  }

  function parseDownloadLinks(data) {
    if (!data || !data.awsLinkExport) return [];
    try {
      var parsed =
        typeof data.awsLinkExport === "string"
          ? JSON.parse(data.awsLinkExport)
          : data.awsLinkExport;
      var links = Array.isArray(parsed && parsed.aws_link)
        ? parsed.aws_link
        : [];
      return links.filter(function (link) {
        return link && link.variant && link.variant !== "preview_link";
      });
    } catch (e) {
      return [];
    }
  }

  function paidOnlyCtaUrl() {
    return window.qdlCustomerId
      ? "/account?tab=membership"
      : "/pages/membership-plans-information";
  }

  function showPaidOnlyRequired() {
    if (typeof showErrorPopup === "function") {
      showErrorPopup(
        "This content is available to paid members only.",
        paidOnlyCtaUrl(),
        "Activate Your Paid Membership"
      );
    }
  }

  function showDownloadLimitReached() {
    if (typeof showErrorPopup === "function") {
      showErrorPopup(
        "Download limit reached! To unlock unlimited access, you'll need to upgrade to a full membership. Upgrading will conclude your free trial, and membership charges will begin right away.",
        "/account?tab=membership",
        "Activate Subscription"
      );
    }
  }

  function showUnavailable() {
    if (typeof showErrorPopup === "function") {
      showErrorPopup(
        "This item is not available for download at the moment. Please try again later or contact support if the issue persists."
      );
    }
  }

  /**
   * Matches validateDownloadPermissions / populateDownloadModal in
   * assets/grouped-products-custom.js exactly, minus the per-bundle
   * "already purchased" allowance (itemAlreadyOrdered), which needs
   * page-scoped cart/order context this flat grid doesn't have:
   *
   * 1. Download limit reached -> blocked, upgrade message.
   * 2. This item is paid-only-locked for the customer -> blocked,
   *    membership-required message.
   * 3. Customer's plan isn't Pro/Media/Trial (covers logged-out guests,
   *    Basic-plan customers, and canceled status) -> add to cart instead,
   *    same as the real product page does silently.
   * 4. Otherwise -> eligible to actually download.
   */
  function resolveDownloadEligibility(data) {
    if (document.body.classList.contains("no-more-downloads")) {
      showDownloadLimitReached();
      return "blocked";
    }
    if (data.paidOnlyLocked) {
      showPaidOnlyRequired();
      return "blocked";
    }
    if (!isPlanAllowed()) {
      return "addToCart";
    }
    return "download";
  }

  function downloadDirect(data) {
    var links = parseDownloadLinks(data);
    if (!links.length) {
      showUnavailable();
      return;
    }
    var link =
      selectLinkByPreference(
        links,
        data.productType,
        getPreferences(data.productType)
      ) || links[0];
    var info = extractLinkInfo(link);
    triggerDownload(link.aws_link, data.title, info.format, info.resolution);
    recordDownload(data, info.format, info.resolution);
  }

  function updateCartIconBubble(sections) {
    if (!sections || !sections["cart-icon-bubble"]) return false;
    var target = document.getElementById("cart-icon-bubble");
    if (!target) return false;
    try {
      var parsed = new DOMParser().parseFromString(
        sections["cart-icon-bubble"],
        "text/html"
      );
      var newSection = parsed.querySelector(".shopify-section");
      if (!newSection) return false;
      target.innerHTML = newSection.innerHTML;
      return true;
    } catch (e) {
      return false;
    }
  }

  function addVariantToCart(variantId) {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var itemInCart = cart.items.find(function (item) {
          return item.variant_id == variantId;
        });
        if (itemInCart) {
          if (typeof showErrorPopup === "function") {
            showErrorPopup(
              "This item is already in your cart. You can only add one of each item."
            );
          }
          return;
        }
        performAddVariantToCart(variantId);
      })
      .catch(function () {
        // If the cart check itself fails, proceed anyway rather than
        // blocking the add - matches product-form.js's own fallback.
        performAddVariantToCart(variantId);
      });
  }

  function performAddVariantToCart(variantId) {
    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: ["cart-icon-bubble"],
      sections_url: window.location.pathname,
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (addResponse) {
        if (addResponse.status) {
          if (typeof showErrorPopup === "function") {
            showErrorPopup(addResponse.description || "Could not add to cart.");
          }
          return;
        }
        if (
          typeof publish === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "quick-download-grid",
            productVariantId: variantId,
            cartData: addResponse,
          });
        }
        updateCartIconBubble(addResponse.sections);
        updateCartCountAfterAdd();
      })
      .catch(function (error) {
        console.error("[quick-download-grid] add to cart error:", error);
        if (typeof showErrorPopup === "function") {
          showErrorPopup("Could not add to cart. Please try again.");
        }
      });
  }

  function updateCartCountAfterAdd() {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (document.querySelector("cart-notification")) {
          if (typeof scrollToTop === "function") scrollToTop();
          if (typeof displayMinicart === "function") {
            displayMinicart(data.items[0]);
          }
        }
      })
      .catch(function (error) {
        console.error("[quick-download-grid] cart count update error:", error);
      });
  }

  var activeTooltip = null;

  function positionFloatingElement(el, anchorRect, options) {
    var gap = (options && options.gap) || 6;
    var placeAbove = (options && options.placeAbove) !== false;
    var elWidth = el.offsetWidth;
    var elHeight = el.offsetHeight;
    var viewportWidth = document.documentElement.clientWidth;
    var idealLeft =
      window.scrollX + anchorRect.left + anchorRect.width / 2 - elWidth / 2;
    var minLeft = window.scrollX + 8;
    var maxLeft = window.scrollX + viewportWidth - elWidth - 8;
    var left = Math.min(
      Math.max(idealLeft, minLeft),
      Math.max(minLeft, maxLeft)
    );
    var top = placeAbove
      ? window.scrollY + anchorRect.top - elHeight - gap
      : window.scrollY + anchorRect.bottom + gap;
    el.style.left = left + "px";
    el.style.top = top + "px";
    // Point the tooltip's arrow at the anchor's horizontal center, even when
    // the tooltip itself has been shifted to stay on-screen near an edge.
    var arrowLeft =
      window.scrollX + anchorRect.left + anchorRect.width / 2 - left;
    el.style.setProperty("--qdl-tooltip-arrow-left", arrowLeft + "px");
  }

  function attachTooltip(button) {
    var text = button.getAttribute("data-tooltip");
    if (!text) return;
    button.addEventListener("mouseenter", function () {
      if (activeTooltip) activeTooltip.remove();
      var tooltip = document.createElement("div");
      tooltip.className = "qdl-tooltip";
      tooltip.textContent = text;
      tooltip.style.visibility = "hidden";
      document.body.appendChild(tooltip);
      positionFloatingElement(tooltip, button.getBoundingClientRect(), {
        placeAbove: true,
        gap: 10,
      });
      tooltip.style.visibility = "";
      activeTooltip = tooltip;
    });
    button.addEventListener("mouseleave", function () {
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
    });
  }

  var HIDE_CONTENT_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M21 12.7549C21 12.9538 20.921 13.1446 20.7803 13.2852C20.6397 13.4259 20.4489 13.5049 20.25 13.5049H3.75C3.55109 13.5049 3.36032 13.4259 3.21967 13.2852C3.07902 13.1446 3 12.9538 3 12.7549C3 12.556 3.07902 12.3652 3.21967 12.2246C3.36032 12.0839 3.55109 12.0049 3.75 12.0049H20.25C20.4489 12.0049 20.6397 12.0839 20.7803 12.2246C20.921 12.3652 21 12.556 21 12.7549Z" fill="white"/></svg>';
  var SHOW_CONTENT_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M16.0312 9.5625C16.0312 9.78628 15.9424 10.0009 15.7841 10.1591C15.6259 10.3174 15.4113 10.4062 15.1875 10.4062H9.84375V15.75C9.84375 15.9738 9.75485 16.1884 9.59662 16.3466C9.43839 16.5049 9.22378 16.5938 9 16.5938C8.77622 16.5938 8.56161 16.5049 8.40338 16.3466C8.24514 16.1884 8.15625 15.9738 8.15625 15.75V10.4062H2.8125C2.58872 10.4062 2.37411 10.3174 2.21588 10.1591C2.05764 10.0009 1.96875 9.78628 1.96875 9.5625C1.96875 9.33872 2.05764 9.12411 2.21588 8.96588C2.37411 8.80764 2.58872 8.71875 2.8125 8.71875H8.15625V3.375C8.15625 3.15122 8.24514 2.93661 8.40338 2.77838C8.56161 2.62014 8.77622 2.53125 9 2.53125C9.22378 2.53125 9.43839 2.62014 9.59662 2.77838C9.75485 2.93661 9.84375 3.15122 9.84375 3.375V8.71875H15.1875C15.4113 8.71875 15.6259 8.80764 15.7841 8.96588C15.9424 9.12411 16.0312 9.33872 16.0312 9.5625Z" fill="white"/></svg>';

  var MODAL_INFORMATION_HTML =
    '<div class="modal-information">' +
    '<div class="header-info">Information' +
    '<span class="hide-content" style="display: none;">' +
    HIDE_CONTENT_ICON +
    "</span>" +
    '<span class="show-content">' +
    SHOW_CONTENT_ICON +
    "</span>" +
    "</div>" +
    '<div class="info-sections">' +
    '<div class="info-sections-container">' +
    '<div class="info-section-left">' +
    '<h3 class="section-title">Resolution</h3>' +
    "<h4>SD, HD or 4K?</h4>" +
    "<p>Media resolution has to do with the level of detail and clarity. It is typically expressed as width x height in pixels. The higher the number of pixels, the more detailed and sharp the media will appear. Use HD or 4k for larger widescreen displays with 16x9 ratio. Use SD for smaller screens that have a 4x3 ratio. Shift Worship Resolution sizes:</p>" +
    '<ul class="resolution-list">' +
    "<li>All 4K Media is 3840 x 2160 pixels. All Media created after December 2017 is available in 4K.</li>" +
    "<li>Our most recent HD Media is 1920 x 1080. HD Media created prior to July 2017 is 1280 x 720.</li>" +
    "<li>The most recent SD Media is 1440 x 1080. Older SD Media sizes were 800 x 600 and 640 x 480.</li>" +
    "</ul>" +
    "</div>" +
    '<div class="info-section-right">' +
    '<h3 class="section-title">Video Formats</h3>' +
    "<h4>MP4, MOV, WMV, MPEG</h4>" +
    "<p>Format refers to the file type or encoding method used to store and display digital media such as images, videos, or audio. Different formats have specific uses, file sizes, and quality characteristics. Every Collection created after December 2018 offers MP4 files (instead of MOV files). Here's a breakdown of the most common media formats and their purposes:</p>" +
    '<ul class="video-list">' +
    "<li>MP4 has become the most universal format for video files, and it is likely the best for both Mac and Windows.</li>" +
    "<li>MOV was the standard for video files for many years for Mac (videos made prior to December 2018 are available in MOV).</li>" +
    "<li>WMV: works well for many Windows users.</li>" +
    "<li>MPEG: is an older format for files created prior to newer formats.</li>" +
    "</ul>" +
    "</div>" +
    "</div>" +
    "</div>" +
    "</div>";

  function wireInformationToggle(content) {
    var infoSections = content.querySelector(".info-sections");
    var hideIcon = content.querySelector(".hide-content");
    var showIcon = content.querySelector(".show-content");
    if (!infoSections || !hideIcon || !showIcon) return;
    infoSections.style.display = "none";
    content
      .querySelector(".header-info")
      .addEventListener("click", function () {
        var isOpen = infoSections.style.display !== "none";
        infoSections.style.display = isOpen ? "none" : "flex";
        hideIcon.style.display = isOpen ? "none" : "block";
        showIcon.style.display = isOpen ? "block" : "none";
      });
  }

  var CLOSE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M16.141 9.92125L13.6707 12.3906L16.141 14.86C16.2107 14.9297 16.2659 15.0124 16.3036 15.1035C16.3414 15.1945 16.3608 15.2921 16.3608 15.3906C16.3608 15.4892 16.3414 15.5868 16.3036 15.6778C16.2659 15.7688 16.2107 15.8516 16.141 15.9213C16.0713 15.9909 15.9886 16.0462 15.8975 16.0839C15.8065 16.1216 15.7089 16.141 15.6104 16.141C15.5118 16.141 15.4142 16.1216 15.3232 16.0839C15.2321 16.0462 15.1494 15.9909 15.0797 15.9213L12.6104 13.4509L10.141 15.9213C10.0713 15.9909 9.98857 16.0462 9.89753 16.0839C9.80648 16.1216 9.7089 16.141 9.61036 16.141C9.51181 16.141 9.41423 16.1216 9.32318 16.0839C9.23214 16.0462 9.14941 15.9909 9.07973 15.9213C9.01005 15.8516 8.95477 15.7688 8.91706 15.6778C8.87935 15.5868 8.85994 15.4892 8.85994 15.3906C8.85994 15.2921 8.87935 15.1945 8.91706 15.1035C8.95477 15.0124 9.01005 14.9297 9.07973 14.86L11.55 12.3906L9.07973 9.92125C8.939 9.78052 8.85994 9.58965 8.85994 9.39062C8.85994 9.1916 8.939 9.00073 9.07973 8.86C9.22046 8.71927 9.41133 8.64021 9.61036 8.64021C9.80938 8.64021 10.0003 8.71927 10.141 8.86L12.6104 11.3303L15.0797 8.86C15.1494 8.79032 15.2321 8.73504 15.3232 8.69733C15.4142 8.65962 15.5118 8.64021 15.6104 8.64021C15.7089 8.64021 15.8065 8.65962 15.8975 8.69733C15.9886 8.73504 16.0713 8.79032 16.141 8.86C16.2107 8.92968 16.2659 9.01241 16.3036 9.10345C16.3414 9.1945 16.3608 9.29208 16.3608 9.39062C16.3608 9.48917 16.3414 9.58675 16.3036 9.6778C16.2659 9.76884 16.2107 9.85157 16.141 9.92125ZM22.3604 12.3906C22.3604 14.319 21.7885 16.2041 20.7172 17.8074C19.6458 19.4108 18.1231 20.6605 16.3415 21.3984C14.5599 22.1364 12.5995 22.3295 10.7082 21.9533C8.81691 21.5771 7.07963 20.6485 5.71606 19.2849C4.3525 17.9214 3.42391 16.1841 3.0477 14.2928C2.67149 12.4014 2.86458 10.441 3.60253 8.65946C4.34048 6.87788 5.59017 5.35514 7.19355 4.2838C8.79693 3.21245 10.682 2.64063 12.6104 2.64062C15.1954 2.64335 17.6737 3.67146 19.5016 5.49935C21.3295 7.32724 22.3576 9.8056 22.3604 12.3906ZM20.8604 12.3906C20.8604 10.7589 20.3765 9.16388 19.47 7.80717C18.5635 6.45046 17.275 5.39304 15.7675 4.76862C14.26 4.1442 12.6012 3.98082 11.0009 4.29915C9.40052 4.61747 7.93051 5.40321 6.77673 6.55699C5.62294 7.71078 4.83721 9.18079 4.51888 10.7811C4.20055 12.3815 4.36393 14.0403 4.98835 15.5478C5.61277 17.0553 6.6702 18.3437 8.0269 19.2502C9.38361 20.1568 10.9787 20.6406 12.6104 20.6406C14.7976 20.6381 16.8946 19.7682 18.4412 18.2215C19.9879 16.6749 20.8579 14.5779 20.8604 12.3906Z" fill="white"/></svg>';

  function closeOptionsModal() {
    if (!activePopover) return;
    activePopover.remove();
    activePopover = null;
  }

  // Mirrors getAvailableCombinations/isValidCombination in
  // assets/grouped-products-custom.js, scoped to one product's own links.
  function buildCombinations(links) {
    return links
      .map(function (link) {
        var parts = (link.variant || "").toLowerCase().split("_");
        return {
          format: parts[0] || "",
          resolution: parts[1] || "",
          width: parts[2] || "sw",
        };
      })
      .filter(function (combo) {
        return combo.format && combo.resolution;
      });
  }

  function isValidCombination(combo, format, resolution, width) {
    return (
      (!format || combo.format === format) &&
      (!resolution || combo.resolution === resolution) &&
      (!width || combo.width === width)
    );
  }

  function renderRadioGroup(
    container,
    name,
    radioClass,
    buttonClass,
    values,
    selectedValue,
    onPick
  ) {
    if (!container) return;
    container.innerHTML = "";
    values.forEach(function (value) {
      var label = document.createElement("label");
      label.innerHTML =
        '<input type="radio" name="' +
        name +
        '" value="' +
        value +
        '" class="' +
        radioClass +
        '"' +
        (value === selectedValue ? " checked" : "") +
        ">" +
        '<button type="button" class="' +
        buttonClass +
        '">' +
        value.toUpperCase() +
        "</button>";
      label.querySelector("button").addEventListener("click", function () {
        label.querySelector('input[type="radio"]').checked = true;
        onPick(value);
      });
      container.appendChild(label);
    });
  }

  function refreshCombinationState(content, combinations, selected) {
    function updateGroup(name, getCombo) {
      content
        .querySelectorAll('input[name="' + name + '"]')
        .forEach(function (radio) {
          var button = radio.nextElementSibling;
          if (!button) return;
          var combo = getCombo(radio.value);
          var valid = combinations.some(function (c) {
            return isValidCombination(
              c,
              combo.format,
              combo.resolution,
              combo.width
            );
          });
          button.classList.toggle("invalid-combination", !valid);
        });
    }
    updateGroup("format", function (value) {
      return {
        format: value,
        resolution: selected.resolution,
        width: selected.width,
      };
    });
    updateGroup("resolution", function (value) {
      return {
        format: selected.format,
        resolution: value,
        width: selected.width,
      };
    });
    updateGroup("width", function (value) {
      return {
        format: selected.format,
        resolution: selected.resolution,
        width: value,
      };
    });
  }

  function openOptionsModal(data) {
    var links = parseDownloadLinks(data);
    if (!links.length) {
      showUnavailable();
      return;
    }
    closeOptionsModal();

    var combinations = buildCombinations(links);
    var formats = [];
    var resolutions = [];
    var widths = [];
    combinations.forEach(function (combo) {
      if (formats.indexOf(combo.format) === -1) formats.push(combo.format);
      if (resolutions.indexOf(combo.resolution) === -1)
        resolutions.push(combo.resolution);
      if (widths.indexOf(combo.width) === -1) widths.push(combo.width);
    });

    var selected = {
      format: formats[0] || null,
      resolution: resolutions[0] || null,
      width: widths.indexOf("sw") !== -1 ? "sw" : widths[0] || "sw",
    };

    var overlay = document.createElement("div");
    overlay.className = "modal downloadModal showConatinerModal";
    overlay.style.position = "fixed";
    overlay.style.display = "block";

    var content = document.createElement("div");
    content.className = "modal-content showModal";
    content.style.display = "block";
    content.style.maxWidth = "1220px";
    content.style.width = "auto";
    content.style.margin = "5% auto";
    content.style.padding = "33px";
    content.innerHTML =
      '<span class="close-modal">' +
      CLOSE_ICON +
      "</span>" +
      '<div class="header-content"><div class="header-container">' +
      (formats.length > 1
        ? '<div class="format-type"><h2>Select Format</h2><div class="format-buttons" data-qdl-formats></div></div>'
        : "") +
      (resolutions.length > 1
        ? '<div class="format-resolution"><h2>Select Your Resolution</h2><div class="format-buttons" data-qdl-resolutions></div></div>'
        : "") +
      (widths.length > 1
        ? '<div class="format-width-popup format-resolution"><h2>Select Width</h2><div class="format-buttons" data-qdl-widths></div></div>'
        : "") +
      "</div></div>" +
      '<button type="button" class="download-btn" style="margin-left: auto; margin-right: auto;">Download</button>' +
      MODAL_INFORMATION_HTML;
    overlay.appendChild(content);

    function onSelect(key, value) {
      selected[key] = value;
      refreshCombinationState(content, combinations, selected);
    }

    renderRadioGroup(
      content.querySelector("[data-qdl-formats]"),
      "format",
      "hidden-format-radio",
      "custom-format-button",
      formats,
      selected.format,
      function (value) {
        onSelect("format", value);
      }
    );
    renderRadioGroup(
      content.querySelector("[data-qdl-resolutions]"),
      "resolution",
      "hidden-resolution-radio",
      "custom-resolution-button",
      resolutions,
      selected.resolution,
      function (value) {
        onSelect("resolution", value);
      }
    );
    renderRadioGroup(
      content.querySelector("[data-qdl-widths]"),
      "width",
      "hidden-resolution-radio",
      "custom-resolution-button",
      widths,
      selected.width,
      function (value) {
        onSelect("width", value);
      }
    );
    refreshCombinationState(content, combinations, selected);
    wireInformationToggle(content);

    content
      .querySelector(".close-modal")
      .addEventListener("click", closeOptionsModal);

    content
      .querySelector(".download-btn")
      .addEventListener("click", function () {
        // Eligibility (plan/paid-only/add-to-cart) was already resolved
        // before this modal was allowed to open - only the download-limit
        // count can still change between then and now.
        if (document.body.classList.contains("no-more-downloads")) {
          showDownloadLimitReached();
          return;
        }
        var match =
          links.find(function (link) {
            var parts = (link.variant || "").split("_");
            var width = parts[2] || "sw";
            return (
              (!selected.format || parts[0] === selected.format) &&
              (!selected.resolution || parts[1] === selected.resolution) &&
              (!selected.width || width === selected.width)
            );
          }) || links[0];
        var info = extractLinkInfo(match);
        triggerDownload(
          match.aws_link,
          data.title,
          info.format,
          info.resolution
        );
        recordDownload(data, info.format, info.resolution);
        closeOptionsModal();
      });

    document.body.appendChild(overlay);
    activePopover = overlay;
  }

  var VIEW_OPTIONS_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.14 12.94c.04-.3.06-.61.06-.94s-.02-.64-.06-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.61-.22l-2.39.96a7.03 7.03 0 0 0-1.62-.94l-.36-2.53A.5.5 0 0 0 14 2h-4a.5.5 0 0 0-.5.42l-.36 2.53c-.59.23-1.14.54-1.62.94l-2.39-.96a.5.5 0 0 0-.61.22l-1.92 3.32a.5.5 0 0 0 .12.64l2.03 1.58c-.04.3-.06.61-.06.94s.02.64.06.94l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32a.5.5 0 0 0 .61.22l2.39-.96c.48.4 1.03.71 1.62.94l.36 2.53A.5.5 0 0 0 10 22h4a.5.5 0 0 0 .5-.42l.36-2.53c.59-.23 1.14-.54 1.62-.94l2.39.96a.5.5 0 0 0 .61-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" fill="white"/></svg>';
  var DOWNLOAD_NOW_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M21.4004 14.25V19.5C21.4004 19.8978 21.2424 20.2794 20.9611 20.5607C20.6797 20.842 20.2982 21 19.9004 21H4.90039C4.50257 21 4.12103 20.842 3.83973 20.5607C3.55843 20.2794 3.40039 19.8978 3.40039 19.5V14.25C3.40039 14.0511 3.47941 13.8603 3.62006 13.7197C3.76071 13.579 3.95148 13.5 4.15039 13.5C4.3493 13.5 4.54007 13.579 4.68072 13.7197C4.82137 13.8603 4.90039 14.0511 4.90039 14.25V19.5H19.9004V14.25C19.9004 14.0511 19.9794 13.8603 20.1201 13.7197C20.2607 13.579 20.4515 13.5 20.6504 13.5C20.8493 13.5 21.0401 13.579 21.1807 13.7197C21.3214 13.8603 21.4004 14.0511 21.4004 14.25ZM11.8698 14.7806C11.9394 14.8504 12.0221 14.9057 12.1132 14.9434C12.2042 14.9812 12.3018 15.0006 12.4004 15.0006C12.499 15.0006 12.5965 14.9812 12.6876 14.9434C12.7786 14.9057 12.8614 14.8504 12.931 14.7806L16.681 11.0306C16.7507 10.9609 16.806 10.8782 16.8437 10.7872C16.8814 10.6961 16.9008 10.5985 16.9008 10.5C16.9008 10.4015 16.8814 10.3039 16.8437 10.2128C16.806 10.1218 16.7507 10.0391 16.681 9.96937C16.6113 9.89969 16.5286 9.84442 16.4376 9.8067C16.3465 9.76899 16.2489 9.74958 16.1504 9.74958C16.0518 9.74958 15.9543 9.76899 15.8632 9.8067C15.7722 9.84442 15.6894 9.89969 15.6198 9.96937L13.1504 12.4397V3.75C13.1504 3.55109 13.0714 3.36032 12.9307 3.21967C12.7901 3.07902 12.5993 3 12.4004 3C12.2015 3 12.0107 3.07902 11.8701 3.21967C11.7294 3.36032 11.6504 3.55109 11.6504 3.75V12.4397L9.18102 9.96937C9.04029 9.82864 8.84941 9.74958 8.65039 9.74958C8.45137 9.74958 8.2605 9.82864 8.11977 9.96937C7.97903 10.1101 7.89997 10.301 7.89997 10.5C7.89997 10.699 7.97903 10.8899 8.11977 11.0306L11.8698 14.7806Z" fill="white"/></svg>';
  var PLAY_BUTTON_OVERLAY =
    '<div class="play-button-overlay" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; align-items: center; justify-content: center;">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none"><path d="M16.3334 3C13.7622 3 11.2488 3.76244 9.11097 5.1909C6.97313 6.61935 5.30689 8.64968 4.32295 11.0251C3.33901 13.4006 3.08156 16.0144 3.58317 18.5362C4.08478 21.0579 5.32291 23.3743 7.14099 25.1924C8.95907 27.0105 11.2755 28.2486 13.7972 28.7502C16.319 29.2518 18.9328 28.9944 21.3083 28.0104C23.6837 27.0265 25.714 25.3603 27.1425 23.2224C28.5709 21.0846 29.3334 18.5712 29.3334 16C29.3297 12.5533 27.9589 9.24882 25.5217 6.81163C23.0846 4.37445 19.7801 3.00364 16.3334 3ZM16.3334 27C14.1578 27 12.031 26.3549 10.2221 25.1462C8.41317 23.9375 7.00327 22.2195 6.1707 20.2095C5.33814 18.1995 5.1203 15.9878 5.54474 13.854C5.96918 11.7202 7.01683 9.7602 8.55521 8.22183C10.0936 6.68345 12.0536 5.6358 14.1874 5.21136C16.3212 4.78692 18.5329 5.00476 20.5429 5.83733C22.5529 6.66989 24.2708 8.07979 25.4795 9.88873C26.6882 11.6977 27.3334 13.8244 27.3334 16C27.3301 18.9164 26.1701 21.7123 24.1079 23.7745C22.0457 25.8367 19.2497 26.9967 16.3334 27ZM20.8884 15.1675L14.8884 11.1675C14.7377 11.067 14.5626 11.0093 14.3818 11.0005C14.2009 10.9918 14.021 11.0323 13.8614 11.1177C13.7017 11.2032 13.5683 11.3304 13.4753 11.4858C13.3823 11.6412 13.3333 11.8189 13.3334 12V20C13.3333 20.1811 13.3823 20.3588 13.4753 20.5142C13.5683 20.6696 13.7017 20.7968 13.8614 20.8823C14.021 20.9677 14.2009 21.0082 14.3818 20.9995C14.5626 20.9907 14.7377 20.933 14.8884 20.8325L20.8884 16.8325C21.0255 16.7412 21.138 16.6175 21.2158 16.4722C21.2936 16.327 21.3344 16.1648 21.3344 16C21.3344 15.8352 21.2936 15.673 21.2158 15.5278C21.138 15.3825 21.0255 15.2588 20.8884 15.1675ZM15.3334 18.1313V13.875L18.5309 16L15.3334 18.1313Z" fill="white"/></svg>' +
    "</div>";

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  // Mirrors the "always-icons" / "hover-icons" markup rendered on the product
  // page's grouped-downloads grid (assets/grouped-products-custom.js), so
  // these tiles use the exact same classes/structure and pick up identical
  // styling from quick-download-grid.css.
  function buildOverlayMarkup(title) {
    var safeTitle = escapeHtml(title);
    var wrap = document.createElement("div");
    wrap.innerHTML =
      '<div class="always-icons">' +
      '<div><p class="product-title" style="visibility:hidden;">' +
      safeTitle +
      "</p></div>" +
      '<div style="display: flex; flex-direction: row; margin-right: 10px; gap: 9px;"></div>' +
      "</div>" +
      '<div class="hover-icons">' +
      '<div><p class="product-title">' +
      safeTitle +
      "</p></div>" +
      '<div style="display: flex; flex-direction: row; margin-right: 10px; gap: 9px;">' +
      '<button type="button" class="qdl-view-options view-options-icon-product" data-tooltip="View Options" aria-label="View download options">' +
      VIEW_OPTIONS_ICON +
      "</button>" +
      '<button type="button" class="qdl-download-now download-icon-product" data-tooltip="Download Now" aria-label="Download now">' +
      DOWNLOAD_NOW_ICON +
      "</button>" +
      "</div>" +
      "</div>";
    return wrap;
  }

  function initTile(tile) {
    if (processedTiles.has(tile)) return;
    processedTiles.add(tile);

    var link = tile.querySelector(".klevuImgWrap a.klevuProductClick");
    var imgWrap = tile.querySelector(".klevuImgWrap");
    if (!link || !imgWrap) return;

    var handle = getProductHandle(link.getAttribute("href"));
    if (!handle) return;

    var titleEl = tile.querySelector(".kuName");
    var title = titleEl ? titleEl.textContent.trim() : "";

    // Appended to .klevuImgWrap (a real <div>, block-level) rather than into
    // the <a> - anchors are inline by default, which made them an unreliable
    // hover trigger / containing block for the absolutely-positioned overlay.
    var fragment = buildOverlayMarkup(title);
    while (fragment.firstChild) {
      imgWrap.appendChild(fragment.firstChild);
    }
    // Keep the hover buttons hidden until product data resolves
    imgWrap.classList.add("qdl-pending");

    var viewOptionsBtn = imgWrap.querySelector(".qdl-view-options");
    var downloadBtn = imgWrap.querySelector(".qdl-download-now");
    if (!window.qdlCustomerId) {
      downloadBtn.setAttribute("data-tooltip", "Add to Cart");
      downloadBtn.setAttribute("aria-label", "Add to cart");
    }
    attachTooltip(viewOptionsBtn);
    attachTooltip(downloadBtn);

    var resolved = false;
    var productData = null;

    function ensureData(callback) {
      if (resolved) {
        callback(productData);
        return;
      }
      fetchQuickDownloadData(handle).then(function (data) {
        resolved = true;
        productData = data;
        if (data) {
          var isCollection =
            (data.productType || "").toLowerCase() === "collections";
          if (isCollection) {
            var alwaysIcons = imgWrap.querySelector(".always-icons");
            var hoverIcons = imgWrap.querySelector(".hover-icons");
            if (alwaysIcons) alwaysIcons.remove();
            if (hoverIcons) hoverIcons.remove();
          } else if (!shouldShowGearButton(data)) {
            viewOptionsBtn.style.display = "none";
          }
          if (data.paidOnlyLocked) {
            var badge = document.createElement("span");
            badge.className = "paid-only-badge";
            badge.textContent = "Members Only";
            imgWrap.insertBefore(badge, imgWrap.firstChild);
          }
          if ((data.productType || "").toLowerCase() === "motions") {
            var playButtonFragment = document.createElement("div");
            playButtonFragment.innerHTML = PLAY_BUTTON_OVERLAY;
            imgWrap.insertBefore(
              playButtonFragment.firstChild,
              imgWrap.querySelector(".always-icons")
            );
          }
        }
        imgWrap.classList.remove("qdl-pending");
        callback(data);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            ensureData(function () {});
            observer.disconnect();
          }
        });
      },
      { rootMargin: "200px" }
    );
    observer.observe(tile);

    viewOptionsBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
      ensureData(function (data) {
        if (!data) {
          showUnavailable();
          return;
        }
        if ((data.productType || "").toLowerCase() === "collections") {
          window.location.href = link.getAttribute("href");
          return;
        }
        var eligibility = resolveDownloadEligibility(data);
        if (eligibility === "blocked") return;
        if (eligibility === "addToCart") {
          addVariantToCart(data.variantId);
          return;
        }
        openOptionsModal(data);
      });
    });

    downloadBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
      ensureData(function (data) {
        if (!data) {
          showUnavailable();
          return;
        }
        if ((data.productType || "").toLowerCase() === "collections") return;
        var eligibility = resolveDownloadEligibility(data);
        if (eligibility === "blocked") return;
        if (eligibility === "addToCart") {
          addVariantToCart(data.variantId);
          return;
        }
        downloadDirect(data);
      });
    });
  }

  function scan(root) {
    (root || document).querySelectorAll(".klevuProduct").forEach(initTile);
  }

  document.addEventListener("DOMContentLoaded", function () {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains("klevuProduct")) {
            initTile(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
